import DescriptionSection from './DescriptionSection';
import DetailsSection from './DetailsSection';

const UserGroupInfo = () => {
  return (
    <>
      <DescriptionSection />
      <DetailsSection />
    </>
  );
};

export default UserGroupInfo;
